<template>
  <div>
    <div class="div-title">
      <label class="label-page-title titleColor">{{message}}</label>
    </div>
    <div class="div-back" @focusout="inputBlur" @focusin="inputFocus">
      <div class="div-information">
        <label class="label-title titleColor">请输入手机号</label>
        <input type="text" class="text-input" id="text-mobile" placeholder="输入手机号" v-model="mobile" maxlength="11"
               :change="checkMobile()">
      </div>
      <div class="div-information">
        <label class="label-title titleColor">请输入验证码</label>
        <input type="text" class="text-input" id="text-verifyCode" placeholder="输入验证码" v-model="verifyCode" maxlength="6"
               :change="checkVerifyCode()">
        <button class="button-get-verifycode" @click="handleVer" :disabled="verDis">{{verText}}</button>
      </div>
      <div class="div-information">
        <label class="label-title titleColor">请输入您的姓名</label>
        <input type="text" class="text-input" id="text-username" placeholder="填写姓名" v-model="username"
               :change="checkUsername()" maxlength="20">
      </div>
      <div class="div-information">
        <label class="label-title titleColor">性别</label>
        <div class="div-radio-boxes">
          <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
            <span class="radio" :class="{'on':item.isChecked}"></span>
            <input v-model="radio" :value="item.value" class="input-radio" :checked='item.isChecked'
                   @click="check(index)" type="radio">{{item.label}}
          </div>
        </div>
      </div>
      <div class="div-information">
        <button class="button-choose-city-back button-clear-style" @click="chooseCity">
          <label class="label-title-choose-city label-title titleColor">意向提车城市</label>
          <input type="text" class="input-choose-city text-input" id="text-city" placeholder="请选择" v-model="city" disabled>
          <img src="../assets/img/icon_usercenter_goods_icon_arrow_go@2x.png" class="image-arrow">
        </button>
      </div>
    </div>
    <button class="button-submit button-clear-style" @click="submit">提交</button>
    <mt-popup class="clearfix" v-model="popupVisibleProvince" position="bottom">
      <div class="div-city-selection clearfix">
        <button class="button-choose-city-cancel button-clear-style" @click="cancelProvince">取消</button>
        <button class="button-choose-city-confirm button-clear-style" @click="confirmProvince">确定</button>
      </div>
      <mt-picker class="class-mt-picker" ref="pickerProvinceRef" :slots="slotsProvince" @change="onvaluesChangeProvince" value-key="name" id="id-picker-province"></mt-picker>
    </mt-popup>
    <mt-popup class="clearfix" v-model="popupVisibleCity" position="bottom">
      <div class="div-city-selection clearfix">
        <button class="button-choose-city-cancel button-clear-style" @click="cancelCity">取消</button>
        <button class="button-choose-city-confirm button-clear-style" @click="confirmCity">确定</button>
      </div>
      <mt-picker class="class-mt-picker" ref="pickerCityRef" :slots="slotsCity" @change="onValuesChangeCity" value-key="city" id="id-picker-city"></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
  import dataServer from '@/api/data'
  import baiduProvincesName from "../components/baiduProvincesName"

    export default {
        name: "reservationAddInformation",
      data() {
        return {
          message: '预约信息',
          mobile: '',
          verifyCode: '',
          verText: '获取验证码',
          verDis: false,
          username: '',
          city: '北京市',
          radio: '',
          radios:[
            {
              label: '先生',
              value:'M',
              isChecked: false,
            },
            {
              label: '女士',
              value:'F',
              isChecked: false,
            }
          ],
          popupVisibleProvince: false,
          popupVisibleCity: false,
          slotsProvince: [{
            flex: 1,
            values: [{'name': '',
                      'type': '',
                      'adcode': '',
                      'data': []}],
            className: 'slot1',
            textAlign: 'center',
            defaultIndex: 0,
          },
          ],
          slotsCity: [{
            flex: 1,
            values: [{
              'city': '',
              'type': '',
              'adcode': '',
              'data': []
            }],
            className: 'slot2',
            textAlign: 'center',
            defaultIndex: 0,
          }
          ],
          selectedProvinceName: '北京市',
          selectedProvinceCode: '110000',
          selectedCityName: '北京市',
          selectedCityCode: '110100',
        }
      },
      methods: {
          //手机限制输入数字
        checkMobile() {
          let regNumeralReplace = /[^\d]/g;
          this.mobile = this.mobile.replace(regNumeralReplace, '');
        },
        //验证码限制输入数字
        checkVerifyCode() {
          let regNumeralReplace = /[^\d]/g;
          this.verifyCode = this.verifyCode.replace(regNumeralReplace, '');
        },
        //限制输入中英文
        checkUsername(){
          let regUsernameReplace = /[^\a-\z\A-\Z\u4e00-\u9fe5]/g;
          this.username = this.username.replace(regUsernameReplace, '');
        },
          /*选择城市*/
        chooseCity() {
          this.popupVisibleProvince = true
          this.getCitiesJson()
          let pickerProvince = document.getElementById('id-picker-province')
          let value = this.slotsProvince[0].values[0]
          this.onvaluesChangeProvince(pickerProvince, [value])
          this.$refs.pickerProvinceRef.setValues([value])
        },
        onvaluesChangeProvince(picker, values) {
          // if (this.popupVisibleProvince) {
            console.log('province change')
          // picker.setSlotValue(0, values[0])
          if (values[0].name.length > 0 || values[0].name != null) {
            this.selectedProvinceName = values[0].name
          }
          if (values[0].adcode.length > 0 || values[0].adcode != null) {
            this.selectedProvinceCode = values[0].adcode
          }
          this.slotsCity[0].values = values[0].data

            console.log(this.selectedProvinceName)
          // }
        },
        onValuesChangeCity(picker, values) {
          // if (this.popupVisibleCity) {
            console.log('city change')
            this.selectedCityName = values[0].city
            this.selectedCityCode = values[0].adcode
            console.log(this.selectedCityName)
          // }
        },
        getCitiesJson() {
          let provinces = baiduProvincesName.data().provinces
          this.slotsProvince[0].values = provinces
        },
        cancelProvince() {
          this.popupVisibleProvince = false
        },
        confirmProvince() {
          this.popupVisibleProvince = false
          this.popupVisibleCity = true

          // let valueFirstProvince = this.slotsProvince[0].values[0]
          let valueCity = this.slotsCity[0].values[0]
          this.$refs.pickerCityRef.setValues([valueCity])
        },
        cancelCity() {
          this.popupVisibleCity = false
        },
        confirmCity() {
          this.popupVisibleCity = false
          this.city = this.selectedCityName
        },
        /*选择男女*/
        check(index) {
          // 先取消所有选中项
          this.radios.forEach((item) => {
            item.isChecked = false;
          });
          //再设置当前点击项选中
          this.radio = this.radios[index].value;
          // 设置值，以供传递
          this.radios[index].isChecked = true;
          console.log(this.radio);
        },
        /*获取验证码*/
        handleVer(){
          let params = {
            mobile: this.mobile,
            verifyCodeUseFlag: 'RESERVATION',
            ruleFlag: 'defaultRule'
          };
          let reg = /^1\d{10}$/;
          if(!reg.test(this.mobile)){
            this.$toast({
              message: '请输入正确的手机号码',
              duration: 1000,
            })
            return
          }
          dataServer.reservationGetVerifyCode(params).then(res => {
            console.log(res)
            if(res.status === 'SUCCEED'){
              let _this = this
              let time = 60;
              _this.verDis = true
              let timeVal = setInterval(function () {
                time--;
                _this.verText = time + ' s'
                if(time === 0){
                  clearInterval(timeVal)
                  _this.verDis = false
                  _this.verText = '获取验证码'
                }
              },1000)
            } 
          })
        },
        /*提交*/
        submit() {
          if (this.mobile.length == 0 || this.mobile == null) {
            this.$toast({
              message: '请输入手机号码',
              duration: 1000,
            })
            return
          }
          let reg = /^1\d{10}$/;
          if(!reg.test(this.mobile)){
            this.$toast({
              message: '请输入正确的手机号码',
              duration: 1000,
            })
            return
          }
          if (this.verifyCode.length == 0 || this.verifyCode == null) {
            this.$toast({
              message: '请输入验证码',
              duration: 1000,
            })
            return
          }
          if (this.username.length == 0 || this.username == null) {
            this.$toast({
              message: '请输入预约人姓名',
              duration: 1000,
            })
            return
          }
          if (this.username.length > 20) {
            this.$toast({
              message: '预约人姓名不超过20个字',
              duration: 1000,
            })
            return
          }
          let regUsername = /^[\u0391-\uFFE5A-Za-z]+$/;
          if(!regUsername.test(this.username)){
            this.$toast({
              message: '预约人姓名仅支持中文、英文、中英文组合',
              duration: 1000,
            })
            return
          }
          if (this.radio.length == 0 || this.radio == null) {
            this.$toast({
              message: '请选择性别',
              duration: 1000,
            })
            return
          }

          if (this.selectedProvinceCode == null || this.selectedProvinceCode.length == 0) {
            this.selectedProvinceCode = "110000"
          }
          if (this.selectedProvinceName == null || this.selectedProvinceName.length == 0) {
            this.selectedProvinceName = "北京市"
          }
          let params = {
            mobile: this.mobile,
            name: this.username,
            sex: this.radio,
            provinceCode: this.selectedProvinceCode,
            provinceName: this.selectedProvinceName,
            cityName: this.selectedCityName,
            cityCode: this.selectedCityCode,
            verifyCode: this.verifyCode,
            platform: 'APP',
          }
          dataServer.reservationAddInfomation(params).then(res => {
            console.log(res)
            if (res.status === 'SUCCEED') {
              this.$toast({
                message: '提交成功',
                duration: 1000,
              })
            }
          })
        },

        inputBlur(e) {
          // 首先，判断触发事件的目标元素是否是input输入框，我们只关注输入框的行为。
          if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
            // 输入框失去焦点，要把IOS键盘推出页面的滚动部分还原。即将页面滚动到视窗顶部对齐
            this.timer = setTimeout(() => {
              window.scrollTo(0,0);
            }, 0)
          }
        },
        inputFocus(e) {
          // 如果focus，则移除上一个输入框的timer
          if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
            clearTimeout(this.timer);
          }
        },
      },
    }
</script>

<style scoped>
  .div-title {}
  .label-page-title {
    color: #222222;
    font-size: 0.18rem;
    margin: 0 auto;
    margin-top: 0.2rem;
    margin-bottom: 0.1rem;
    display: block;
    text-align: center;
    font-weight: 500;
  }

  input {
    background: none;
    border: none;
    -webkit-appearance:none;
    -moz-appearance: none;
    outline: 0;
  }

  input::-webkit-input-placeholder {
    color: #DDDDDD;
    font-size: 0.16rem;
  }

  .div-radio-boxes {
    margin-top: -0.45rem;
    margin-left: 0.8rem;
  }

  .radio-box {
    display: inline-block;
    position: relative;
    height: 0.25rem;
    line-height: 0.25rem;
    margin-right: 0.05rem;
    margin-left: 0.4rem;
    /*background-color: red;*/
  }
  .radio {
    display: inline-block;
    width: 0.25rem;
    height: 0.25rem;
    vertical-align: middle;
    cursor: pointer;
    background-image: url(../assets/img/icon_unsel@2x.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .input-radio {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 0.25rem;
    height: 0.25rem;
    cursor: pointer;
    left: 0;
    outline: none;
    -webkit-appearance: none;
  }
  .on {
    background-image: url(../assets/img/icon_sel@2x.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .div-information {
    margin-left: 0.15rem;
    margin-right: 0.15rem;
    border-bottom: 1px solid #D8D8D8;
    height: 0.6rem;
  }

  .label-title {
    color: #999999;
    font-size: 0.14rem;
    vertical-align: middle;
    line-height: 0.6rem;
  }

  .label-title-choose-city {
    float: left;
  }

  .text-input {
    color: #333333;
    font-size: 0.16rem;
    vertical-align: middle;
    margin-left: 0.43rem;
  }

  .input-choose-city {
    float: left;
    height: 0.6rem;
  }

  #text-mobile, #text-verifyCode {
    margin-left: 0.43rem;
  }
  #text-verifyCode {
    width: 0.9rem;
  }
  #text-username {
    margin-left: 0.29rem;
  }
  #text-city {
    margin-left: 0.43rem;
  }

  .button-get-verifycode {
    border: none;
    outline: none;
    background: none;
    color: #4798CB;
    font-size: 0.16rem;
    float: right;
    margin-top: 0.2rem;
  }

  .button-get-verifycode[disabled]{
    color: #90C1E0 !important;
  }

  .class-mt-picker {
    width: 3.8rem;
    height: 2.5rem;
    display: inline;
  }

  .button-clear-style {
    border: none;
    outline: none;
    background: none;
  }
  .button-choose-city-cancel {
    color: #666666;
    font-size: 0.16rem;
    float: left;
  }
  .button-choose-city-confirm {
    color: #4798CB;
    font-size: 0.16rem;
    float: right;
  }

  .image-arrow {
    width: 0.16rem;
    height: 0.16rem;
    float: left;
    margin-top: 0.22rem;
  }

  .div-choose-city {
    width: 100%;
    height: 100%;
    float: left;
    margin-top: -0.6rem;
  }
  .button-choose-city {
    width: 100%;
    height: 100%;
    background-color: yellowgreen;
  }

  .button-choose-city-back {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .button-submit {
    background-color: #4798CB;
    font-size: 0.16rem;
    width: 3.45rem;
    height: 0.4rem;
    horiz-align: center;
    color: #ffffff;
    border-radius: 0.04rem;
    display: block;
    margin: 0 auto;
    margin-top: 0.5rem;
  }

  .div-city-selection {
    margin-top: 0.1rem;
  }
  .mint-popup-bottom {
    width: 100%;
  }
  .class-mt-picker {
    margin-top: 0.1rem;
  }

  .darkMode .text-input{
    color: #FFFFFF !important;
  }

  .darkMode input::-webkit-input-placeholder{
          color: #CAC8CB !important;
  }
  .darkMode input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color: #CAC8CB !important;
  }
  .darkMode input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
      color: #CAC8CB !important;
  }
  .darkMode input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
      color: #CAC8CB !important;
  }
  .darkMode .text-input{
    color: #FFFFFF !important;
  }

</style>

